<template>
  <div class="home">
    <ul class="filters">
      <li>
        <a v-on:click="showPros" v-bind:class="{ selected: filter === 'pros' }"
          >PROs</a
        >
      </li>
      <li>
        <a
          v-on:click="showVerifications"
          v-bind:class="{ selected: filter === 'verifications' }"
          >Verifications</a
        >
      </li>
      <li>
        <a
          v-on:click="showClients"
          v-bind:class="{ selected: filter === 'clients' }"
          >Clients</a
        >
      </li>
      <li>
        <a
          v-on:click="showOffenders"
          v-bind:class="{ selected: filter === 'offenders' }"
          >Offenders</a
        >
      </li>
      <li>
        <a
          v-on:click="showDebtors"
          v-bind:class="{ selected: filter === 'debtors' }"
          >Debtors</a
        >
      </li>
      <li>
        <a
          v-on:click="showSearch"
          v-bind:class="{ selected: filter === 'search' }"
          >Search</a
        >
      </li>
    </ul>
    <div id="users-table" class="data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>Platform</div>
        <div>PID</div>
        <div>Area/Email</div>
        <div>Name</div>
        <div>Phone</div>
        <div>CreatedAt</div>
        <div>Verified</div>
        <div>Actions</div>
      </div>
      <div v-if="filter === 'search'" class="row">
        <div class="cell id inputcell"><input style="width:300px" placeholder="Enter ID" v-model.trim="searchId" autofocus /></div>
        <div class="cell inputcell"></div>
        <div class="cell inputcell">
          <input style="width:100px" placeholder="Enter PID" v-model.trim="searchPid"  />
          <input style="width:100px" placeholder="Business ID" v-model.trim="searchBusinessCode"  />
        </div>
        <div class="cell inputcell">
          <div v-if="searchLocation">{{ searchLocation.address }}</div>
        </div>
        <div class="cell inputcell"><div style="display:flex"><input style="max-width: 100px" placeholder="First Name" v-model.trim="searchFirstName"  /><input style="max-width: 100px" placeholder="Last Name" v-model.trim="searchLastName" /></div></div>
        <div class="cell inputcell"><input placeholder="Phone" v-model.trim="searchPhone"  /></div>
        <div class="cell inputcell"></div>
        <div class="cell inputcell"></div>
        <div class="cell actions" style="display: flex">
          <button
            v-on:click="clearSearch()"
          >
            Clear
          </button>
          <button
            v-on:click="search()"
          >
            Search
          </button>
        </div>
      </div>
      <div
        v-for="user in users"
        v-bind:key="user.id"
        class="row"
        v-bind:class="{ disabled: user.ordersDisabled }"
      >
        <div class="cell id">{{ user.id }}</div>
        <div class="cell">{{ user.registrationGui }}:{{user.appVersion}}:{{user.appLocale}}</div>
        <div class="cell">{{ user.proId }}</div>
        <div class="cell">
          <router-link :to="{ name: 'userProfile', params: { id: user.id } }">{{
            user.serviceArea ? user.serviceArea.text : user.email
          }}</router-link>
          {{user.distance ? user.distance.toFixed(2) + ' km' : '' }}
        </div>
        <div class="cell">
          {{ user.firstName }} {{ user.lastName }}
          {{ user.averageRating ? "[" + user.averageRating + "]" : "" }}
        </div>
        <div class="cell">{{ user.phoneNumber }}</div>
        <div class="cell">
          {{
            user.createdAt
              ? new Date(user.createdAt._seconds * 1000).toLocaleDateString()
              : "-"
          }}
        </div>
        <div class="cell">
          {{
            getVerifiedIndicator(user)
          }}
          <p v-if="user.legalStatus"><span style="color:red">OFFENDER</span></p>
          <p v-if="user.debt > 0"><span style="color:red">DEBTOR {{ user.debt / 100 }}</span></p>
          <p v-if="user.debt < 0"><span style="color:red">CREDITOR {{ user.debt / 100 }}</span></p>
        </div>
        <div class="cell actions" style="display: flex">
          <p v-if="user.accountDeletionRequestedAt">DELETE ACCOUNT</p>
          <p v-if="user.awaitingVerification">WAIT FOR VERIFY</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
#users-table {
  grid-template-columns: auto auto auto auto auto auto auto auto auto;
  .row.disabled .cell {
    color: #aaa;
  }
  .cell input {
    padding: 10px;
  }
  .inputcell {
    padding: 0;
  }
  @media only screen and (max-width: 1000px) {
    .cell.id {
      display: none;
    }
    .header .id {
      display: none;
    }
    grid-template-columns: auto auto auto auto auto auto auto auto;
  }
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";

export default {
  name: "home",
  data: function() {
    return {
      users: [],
      filter: "taskers",
      searchId: '',
      searchFirstName: '',
      searchLastName: '',
      searchPid: '',
      searchPhone: '',
      searchLocation: '',
      searchBusinessCode: ''
    };
  },
  methods: {
    getVerifiedIndicator: function(user) {
      let text = user.businessCode ||
              user.verified ||
              (user.skills ? "Skills: " + user.skills.length : "");
      if (user.proType) {
        text += ':business';
      }
      return text;
    },
    sortUsers: function(users) {
      return users.sort((u1, u2) => {
        let t1 = (u1.createdAt || { _seconds: 0 })._seconds;
        let t2 = (u2.createdAt || { _seconds: 0 })._seconds;
        if (u1.awaitingVerification || u1.accountDeletionRequestedAt) {
          t1 = t1 + 999999999999;
        }
        if (u2.awaitingVerification || u2.accountDeletionRequestedAt) {
          t2 = t2 + 999999999999;
          // console.log(t1, t2);
        }
        return t2 - t1;
      });
    },
    clearSearch: async function() {
      this.searchId = '';
      this.searchFirstName = '';
      this.searchLastName = '';
      this.searchPhone = '';
      this.searchPid = '';
      this.searchLocation = '';
      this.searchBusinessCode = '';
      this.users=[];
    },
    search: async function() {
      if (this.searchLocation) {
        this.users = await api.searchUsersByLocation({location: this.searchLocation});
      } if (this.searchId) {
        this.users = this.sortUsers(await api.searchUsers({id: this.searchId}));
      } else if (this.searchPid) {
        this.users = this.sortUsers(await api.searchUsers({pid: this.searchPid}));
      } else if (this.searchFirstName) {
        this.users = this.sortUsers(await api.searchUsers({firstName: this.searchFirstName}));
      } else if (this.searchLastName) {
        this.users = this.sortUsers(await api.searchUsers({lastName: this.searchLastName}));
      } else if (this.searchPhone) {
        this.users = this.sortUsers(await api.searchUsers({phoneNumber: this.searchPhone}));
      } else if (this.searchBusinessCode) {
        this.users = this.sortUsers(await api.searchUsers({businessCode: this.searchBusinessCode}));
      }
    },
    searchChange: function() {
      this.filter = "search";
      const term = this.search.toLowerCase();
      this.users = this.allUsers.filter(user => {
        if (
          (
            (user.firstName || '').toLowerCase() +
            " " +
            (user.lastName || '').toLowerCase()
          ).indexOf(term) !== -1 ||
          (user.phoneNumber || '').indexOf(term) !== -1 ||
          (user.email || '').toLowerCase().indexOf(term) !== -1 ||
          user.id.toLowerCase().indexOf(term) !== -1
        ) {
          return true;
        }
        return false;
      });
    },
    showPros: async function() {
      document.title = 'PROs/Users';
      this.$router
        .push({ name: "users", query: { filter: "pros" } })
        .catch(() => {});
      this.users = this.sortUsers(await api.getPros());
      this.filter = "pros";
      // this.search = "";
    },
    showSearch: async function(params = {}) {
      document.title = 'Search/Users';
      this.$router
        .push({ name: "users", query: { filter: "search", ...params } })
        .catch(() => {});
      this.users = [];
      this.filter = "search";
      if (params.address) {
        this.searchLocation = {
          address: params.address,
          lat: params.lat,
          lng: params.lng,
          country: params.country
        }
        this.search();
      } else if (params.businessCode) {
        this.searchBusinessCode = params.businessCode;
        this.search();
      }
    },
    showClients: async function() {
      document.title = 'Clients/Users';
      this.$router
        .push({ name: "users", query: { filter: "clients" } })
        .catch(() => {});
      this.users = this.sortUsers(await api.getClients());
      this.filter = "clients";
      // this.search = "";
    },
    showOffenders: async function() {
      document.title = 'Offenders/Users';
      this.$router
        .push({ name: "users", query: { filter: "offenders" } })
        .catch(() => {});
      this.users = this.sortUsers(await api.getOffenders());
      this.filter = "offenders";
      // this.search = "";
    },
    showDebtors: async function() {
      document.title = 'Debtors/Users';
      this.$router
        .push({ name: "users", query: { filter: "debtors" } })
        .catch(() => {});
      this.users = this.sortUsers(await api.getDebtors());
      this.filter = "debtors";
      // this.search = "";
    },
    showVerifications: async function() {
      document.title = 'Verifications/Users';
      this.$router
        .push({ name: "users", query: { filter: "verifications" } })
        .catch(() => {});
      this.filter = "verifications";
      // this.search = "";
      this.users = [];
      const users = await api.getVerifications();
      this.users = users.sort((u1, u2) => {
        // console.log(u1.createdAt.seconds, u2.createdAt.seconds);
        return (u2.createdAt._seconds - u1.createdAt._seconds);
      });
    },
    navigate(route) {
      const filter = route.query.filter;
      if (filter === "clients") {
        this.showClients();
      } else if (filter === 'verifications') {
        this.showVerifications();
      } else if (filter === 'offenders') {
        this.showOffenders();
      } else if (filter === 'debtors') {
        this.showDebtors();
      } else if (filter === 'search') {
        this.showSearch(route.query);
      } else {
        this.showPros();
      }
    }
  },
  // watch: {
  //   $route(to) {
  //     this.navigate(to);
  //   }
  // },
  created: async function() {
    this.allUsers = [];
    this.users = [];
    this.navigate(this.$route);
    // console.log(this.users);
    // console.log(this.orders.map((order, i) => ({...order, id: i})));
  }
  // components: {
  //   HelloWorld
  // }
};
</script>
